<h2 mat-dialog-title>Seleciona o serviço a ser realizado:</h2>
<mat-dialog-content class="mat-typography">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

  <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 5px">
    <mat-label>Serviços</mat-label>
    <mat-select *ngIf="healthcareservice" [(ngModel)]="healthcareSelected" multiple>
      <mat-option *ngFor="let item of healthcareservice" [value]="item" [disabled]="isAlreadyLinked(item)" aria-placeholder="Escolha a especialidade">
        {{ item.name }}
        <span *ngIf="isAlreadyLinked(item)" class="linked-badge">(já vinculada)</span>
      </mat-option>

      <mat-option *ngIf="healthcareservice.length === 0" disabled>
       Nenhuma especialidade disponível
      </mat-option>
    </mat-select>
    <mat-error *ngIf="!healthcareSelected || healthcareSelected.length === 0"> Campo obrigatório </mat-error>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="warn" [mat-dialog-close]="false">Cancelar</button>
  <button mat-flat-button [disabled]="healthcareSelected.length == 0" (click)="createAffiliation()" color="primary" cdkFocusInitial>
    Confirmar
  </button>
</mat-dialog-actions>
